import type { ReactNode } from "react"
import { cn } from "@/shared/lib/utils"
import { Drawer, DrawerContent, DrawerTitle } from "@/shared/ui/drawer"

/**
 * Нижняя шторка для телефона (Drawer из shadcn): закрывается тапом по фону или жестом вниз.
 * Фокус при открытии не ставим, иначе сразу выезжает клавиатура.
 */
export function BottomSheet({
	open,
	onOpenChange,
	title,
	children,
	className,
}: {
	open: boolean
	onOpenChange: (open: boolean) => void
	title: string
	children: ReactNode
	className?: string
}) {
	return (
		<Drawer open={open} onOpenChange={onOpenChange} repositionInputs={false}>
			<DrawerContent
				aria-describedby={undefined}
				onOpenAutoFocus={(event) => event.preventDefault()}
				className={cn("h-[88dvh] max-h-[88dvh] pb-[var(--app-safe-bottom)]", className)}
			>
				<DrawerTitle className="px-4 pt-2 pb-1 text-base font-semibold">{title}</DrawerTitle>
				<div className="min-h-0 flex-1">{children}</div>
			</DrawerContent>
		</Drawer>
	)
}
